<template>

    <div class="view-action-map">
        <cms-heading title="Actie kaart" level="2">

            <template v-if="isAdminOrAdvisor">

                <cms-button v-if="!exporting && !updatingStatus"  icon="magicon-jump-right-up" @click="exporting = true">Exporteer acties</cms-button>
                <div v-if="exporting" class="export-map">
                    <span>Selecteer een gebied op de kaart om te exporteren</span>
                    <cms-button :disabled="!selectedMarkerIds" @click="exportActions()">Exporteren</cms-button>
                    <cms-button color="default-light" @click="resetExport">Annuleren</cms-button>
                </div>

                <cms-button v-if="!updatingStatus && !exporting"  icon="magicon-edit" @click="updatingStatus = true">Status wijzigen (max. 25 acties)...</cms-button>
                <div v-if="updatingStatus" class="update-status-map">
                    <span>Selecteer een gebied op de kaart om de status te wijzigen</span>
                    <cms-dropdown :disabled="!selectedMarkerIds" placeholder="Status wijzigen..." :options="stateOptions" @input="updateStatus"></cms-dropdown>
                    <cms-button color="default-light" @click="resetUpdateStatus">Annuleren</cms-button>
                </div>

            </template>

        </cms-heading>

        <open-layers-map :markers="markers" :selectable="exporting || updatingStatus" clustered
                         @marker-click="onMarkerClick" @selection="onSelection" v-spinner="loading" />
    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'

    import ActionQueries from 'app/queries/ActionQueries'
    import OpenLayersMap from "app/components/ui/OpenLayersMap.vue";

    import { transform as transformProjection } from 'ol/proj'

    import actionStateHexFilter from "app/filters/actionStateHex";
    import UserRole from "app/enums/UserRole";
    import ActionState from "app/enums/ActionState";

    const OPEN_ACTION_STATES_LIST = [ActionState.PENDING];

    @Component({

        name: 'actions-map',
        components: { OpenLayersMap },
        props: ['filter'],
        apollo: {

            actions: ActionQueries.all({

                fetchPolicy: 'cache-and-network',
                variables(){

                    return {
                        filter: {
                            ...this.filter,
                            ...!this.filter?.state?.length ? { state: [ActionState.PENDING, ActionState.IN_PROCESS, ActionState.ACTION_PL, ActionState.ON_HOLD] } : {}
                        },
                        requireLocation: true
                    }
                }
            })
        }
    })
    export default class ActionsMap extends Vue
    {
        data(){

            return {

                actions: null,
                loading: 0,
                exporting: false,
                updatingStatus: false,
                selectedMarkerIds: null
            }
        }

        created(){

            this.logger = this.$logger.child('ActionsMap');
        }

        refetch(){

            this.refetchQuery('actions');
            this.resetUpdateStatus();
        }

        onQueryError(error){

            this.logger.error(error);
            this.$toast.error('De gegevens konden niet worden opgehaald');
        }

        showAction(action){

            this.$router.push({

                name: 'action-view',
                params: { id: action.id }
            });
        }

        onMarkerClick(id){

            this.$router.push({

                name: 'action-view',
                params: { id }
            });
        }

        onSelection(markers){

            this.selectedMarkerIds = markers;
        }

        get markers(){

            if(!this.actions){
                return [];
            }

            return this.actions.items.map(action => {

                const isOpen = OPEN_ACTION_STATES_LIST.indexOf(action.state) >= 0;
                let color = actionStateHexFilter(action.state);

                if(isOpen && action.deadline !== this.$config.defaultActionDeadline){
                    color = '#c700ff';
                }

                return {
                    id: action.id,
                    coordinates: transformProjection([action.locationLng, action.locationLat], 'EPSG:4326', 'EPSG:28992'),
                    color: color
                };
            });
        }

        exportActions(){

            if(!this.selectedMarkerIds){
                return;
            }

            let queryParams = [];
            queryParams.push('requireLocation=true');
            queryParams.push('sortField=createdAt');
            queryParams.push('sortDirection=DESC');
            queryParams.push('filter=' + JSON.stringify(this.filter));
            queryParams.push('ids=' + this.selectedMarkerIds.join(','));

            window.open(this.$config.apiUrl + '/export/csv/actions?' + encodeURI(queryParams.join('&')));

            this.resetExport();
        }

        updateStatus(state){

            this.$emit('update-state', {
                state,
                actionIds: this.selectedMarkerIds
            });
        }

        resetExport(){

            this.exporting = false;
            this.selectedMarkerIds = null;
        }

        resetUpdateStatus(){

            this.updatingStatus = false;
            this.selectedMarkerIds = null;
        }

        get isAdminOrAdvisor(){

            return [UserRole.ADVISOR, UserRole.ADMIN].indexOf(this.$user.role) >= 0;
        }

        get stateOptions(){

            return ActionState.options();
        }
    }

</script>
